export default __webpack_public_path__ + "media/images/times-0e5ddbb58ec62615970bb0a54ce331c8.svg";